/** Must stay in sync with `Configuration::VitalSign::VitalSignItem::ALLOWED_FREQUENCIES` on the back */
export const VITAL_SIGN_FREQUENCIES = [
  "1-day",
  "3-day",
  "1-week",
  "2-week",
  "1-month",
  "2-month",
  "3-month",
  "6-month",
  "1-year",
  "never"
] as const;

type FREQUENCY = (typeof VITAL_SIGN_FREQUENCIES)[number];

export default class VitalSignItem {
  constructor(
    public id: keyof VitalSignRegistry,
    public enabled: boolean,
    public frequency?: FREQUENCY,
    public forgettingNumber?: number
  ) {}
}
